import {
	getIncotermsRequest,
	newIncotermRequest,
	deleteIncotermRequest,
	updateIncotermRequest,
	syncIncotermsRequest,
	getFilteredGlobalUniquePostalPlacesRequest
} from '../requests';
import { throttle, objectGet, objectSet } from '@/core';
import rdbClient from 'rdb-client';
import deepCopy from 'deepcopy';

async function getIncoterms({ state, commit }, { force } = {}) {
	commit('set', (state) => { state.loading = true; });
	try {
		if (force || state.incoterms.length === 0) {
			await fetchIncoterms();
		} else {
			await throttle(fetchIncoterms, 'fetchIncoterms', 60 * 1000);
		}
	} catch (err) {
		console.error(err);
		throw new Error('failedToFetch');
	}
	commit('set', (state) => { state.loading = false; });

	async function fetchIncoterms() {
		let response = await getIncotermsRequest();
		commit('setIncoterms', response);
	}
}

async function addIncoterm({ state, commit }) {
	let incoterm = {
		id: null,
		code: '',
		description: {},
		getCustomerFrom: undefined,
		getAddressFrom: undefined
	};
	try {
		let response = await newIncotermRequest(incoterm);
		incoterm.id = response.id;
		let { incoterms } = state;
		incoterms.unshift(incoterm);
		commit('set', () => { state.incoterms = incoterms; });
	} catch (err) {
		throw new Error('failedToAdd');
	}

	return incoterm;
}

async function setIncoterm({ commit }, { incoterm, data, prop }) {
	let originalValue = objectGet(incoterm, prop);
	if (originalValue === data) return;

	let incotermClone = deepCopy(incoterm);
	commit('set', () => { objectSet(incoterm, prop, data); });
	let patch = rdbClient.createPatch(incotermClone, incoterm);
	try {
		await updateIncotermRequest(incoterm.id, { patch });
		commit('clearErrors');
	} catch (err) {
		if (err.response) {
			commit('setErrors', { errors: err.response.data.errors, id: incoterm.id });
		}
		commit('set', () => { objectSet(incoterm, prop, originalValue); });
		throw (err);
	}
}

async function deleteIncoterms({ state, commit }, incotermsToDelete) {
	let storedIncoterms = state.incoterms;
	let idsToRemove = [];
	for (let dIncoterm of incotermsToDelete) {
		idsToRemove.push(dIncoterm.id);
	}
	try {
		for (let incotermId of idsToRemove) {
			await deleteIncotermRequest(incotermId);
		}
		let updatedIncoterms = storedIncoterms.filter(term => idsToRemove.indexOf(term.id) < 0);
		commit('set', () => { state.incoterms = updatedIncoterms; });
	} catch (err) {
		throw new Error('failedToDelete');
	}
}

async function syncIncoterms() {
	try {
		await syncIncotermsRequest();
	} catch (err) {
		throw new Error('failedToSync');
	}
}

async function getFilteredGlobalUniquePostalPlaces({}, filterString) {
	let response = [];
	try {
		response = await getFilteredGlobalUniquePostalPlacesRequest( filterString );
	} catch (err) {
		throw new Error('failedToFetch');
	}
	return response;
}

export default {
	getIncoterms,
	addIncoterm,
	setIncoterm,
	deleteIncoterms,
	syncIncoterms,
	getFilteredGlobalUniquePostalPlaces,
};
